export default "__VITE_ASSET__8865d9b9__"